// extracted by mini-css-extract-plugin
export var active = "Breadcrumb-module--active--94fa3";
export var breadcrumb = "Breadcrumb-module--breadcrumb--93742";
export var separator = "Breadcrumb-module--separator--429dc";